import apiClient from 'BrokerTsLib/src/Utils/apiClient'
import { useMutation, useQuery } from '@tanstack/react-query'
import { useUrl } from '.'
import { Apis } from '../appSettings/AppSettings'

/** Ne-terminální saga pojištění (viz InsuranceSagasController.GetActiveSagas). */
export interface ActiveInsuranceSaga {
  sagaId: string
  /** Název SagaEventTypes, např. 'CANCELLATION'. */
  eventType: string
  /** Pozice stavového automatu, např. 'PENDING_START'. */
  stateName?: string | null
  /** Kořen pro odběr na SagaWorkflowHub (u dětí orchestrátoru id rodiče). */
  rootSagaId: string
}

export interface ActiveInsuranceSagasResponse {
  sagas: ActiveInsuranceSaga[]
}

export interface CancelInsuranceSagaResult {
  success: boolean
  error?: string | null
}

/** Ne-terminální sagy pojištění — klient z nich odvozuje akce a odebírá jejich kořeny na hubu. */
export const useGetActiveSagas = (insuranceId: number | undefined, enabled = true) => {
  const url = useUrl(Apis.errorHandlingSagas)

  return useQuery({
    queryKey: ['activeInsuranceSagas', insuranceId],
    enabled: !!insuranceId && enabled,
    queryFn: async () => {
      const res = await apiClient.get<ActiveInsuranceSagasResponse>(`${url}/GetActiveSagas`, { params: { insuranceId } })
      return res.data
    },
    retry: false,
  })
}

/** Obecné zrušení čekající retryable sagy (publikuje CancelRetryable, zpracování je asynchronní). */
export const useCancelSaga = () => {
  const url = useUrl(Apis.errorHandlingSagas)

  return useMutation({
    mutationFn: (request: { sagaId: string; reason?: string }) =>
      apiClient.post<CancelInsuranceSagaResult>(`${url}/CancelSaga`, request).then(r => r.data),
  })
}
